export const navigation = [
  {
    text: 'Riportok',
    path: '/reports',
    icon: 'textdocument',
  },
  {
    text: 'Súgó',
    path: '/help',
    icon: 'help'
  },
  {
    text: 'Help Text',
    path: '/help/help-text',
    icon: 'help'
  },
];
